import { useEffect, useState } from 'react';

export const useDateCheck = (targetDateInput: Date) => {
  const [isTargetDate, setIsTargetDate] = useState<boolean>(false);

  useEffect(() => {
    const isTargetDateBiggerThatCurrentDate = new Date().getTime() > targetDateInput.getTime();

    setIsTargetDate(isTargetDateBiggerThatCurrentDate);

    const timerId = setInterval(() => {
      setIsTargetDate(isTargetDateBiggerThatCurrentDate);
    }, 1000);

    return () => clearInterval(timerId);
  }, [targetDateInput]);

  return { isTargetDate };
};
